import { render } from "./HomeCard.vue?vue&type=template&id=9f5bfc8c"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__